export type DesktopShortcut =
  | 'toggle-heading'
  | 'toggle-bold'
  | 'toggle-italic'
  | 'edit-link'
  | 'delete-line'
  | 'delete-note'
  | 'copy-markdown'
  | 'toggle-quick-access'
  | 'toggle-tags'
  | 'open-reminder'
  | 'toggle-underline'
  | 'suppress-legacy-underline'
  | 'new-note'
  | 'focus-search'
  | 'show-shortcuts'

export interface DesktopShortcutKeyEvent {
  altKey: boolean
  code: string
  ctrlKey: boolean
  metaKey: boolean
  shiftKey?: boolean
}

/**
 * One physical-key map shared by app capture and the editor fallback.
 * Letter commands use Control+Shift (also on macOS), never Option dead keys.
 */
export function getDesktopShortcut(event: DesktopShortcutKeyEvent): DesktopShortcut | null {
  if (event.ctrlKey && event.shiftKey && !event.altKey && !event.metaKey) {
    switch (event.code) {
      case 'KeyH': return 'toggle-heading'
      case 'KeyB': return 'toggle-bold'
      case 'KeyI': return 'toggle-italic'
      case 'KeyL': return 'edit-link'
      case 'KeyD': return 'delete-note'
      case 'KeyC': return 'copy-markdown'
      case 'KeyQ': return 'toggle-quick-access'
      case 'KeyT': return 'toggle-tags'
      case 'KeyR': return 'open-reminder'
      case 'KeyU': return 'toggle-underline'
      case 'KeyN': return 'new-note'
      case 'KeyS': return 'focus-search'
      default: return null
    }
  }

  if (event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey && event.code === 'Period') {
    return 'delete-line'
  }

  if (!event.altKey && !event.shiftKey && (event.metaKey !== event.ctrlKey) && event.code === 'KeyU') {
    return 'suppress-legacy-underline'
  }

  if (!event.altKey && !event.shiftKey && (event.metaKey !== event.ctrlKey) && event.code === 'Slash') {
    return 'show-shortcuts'
  }

  return null
}
